window.customElements.define('page-mainnav', class extends HTMLElement {
  constructor() {
    super();
    this.$lists = this.querySelectorAll('.mainnav-content__list');
    this.$subs = this.querySelectorAll('.mainnav-content');
    this.$links = this.querySelectorAll('.mainnav__link');
    this.$content = this.querySelectorAll('.mainanv-content__nav');
    this.$cards = this.querySelectorAll('.mainnav__cards');

    window.addEventListener('click', (e) => {
      if (e.target.closest('.language__trigger')) {
        this.hideSubs();
      }
    });

    window.addEventListener('click', (e) => {
      if (!e.target.closest('page-bar')) {
        this.hideSubs();
      }
    });

    window.addEventListener('scroll', () => {
      if (this.$cards[0]) {
        const cardsBottom = this.$cards[0].getBoundingClientRect().bottom;
        if (window.scrollY > cardsBottom) {
          this.hideSubs();
        }
      }
    });

    this.setEqual();

    this.addEventListener('click', (e) => {
      const $currentSub = e.target.nextElementSibling;
      if ($currentSub && $currentSub.classList.contains('mainnav-content')) {
        e.preventDefault();
        $currentSub.classList.toggle('is-active');
        e.target.classList.toggle('is-active');
        if (window.videosLoaded) {
          if ($currentSub.classList.contains('is-active')) {
            window.pauseVideo();
          } else {
            window.playVideo();
          }
        }
      }
    });

    this.addEventListener('click', (e) => {
      const clickedLink = e.target.closest('.mainnav-content__link');
      if (clickedLink && !clickedLink.classList.contains('no__children')) {
        e.preventDefault();
        this.toggleActiveClass(clickedLink.querySelector('a'));
      }
    });

    this.addEventListener('click', (e) => {
      const clickedItem = e.target.closest('.mainnav__item');
      if (clickedItem) {
        this.removeActiveClasses(clickedItem);
      }
    });
  }

  hideSubs() {
    this.$subs.forEach(($sub) => $sub.classList.remove('is-active'));
    this.$links.forEach(($link) => $link.classList.remove('is-active'));
    if (window.videosLoaded) {
      window.playVideo();
    }
  }

  setEqual() {
    let maxHeight = 0;

    // Calculate maxHeight for lists
    this.$lists.forEach(($list) => {
      const listHeight = $list.offsetHeight;
      maxHeight = Math.max(maxHeight, listHeight);
    });

    // Set minHeight for lists
    this.$lists.forEach(($list) => {
      Object.assign($list.style, { minHeight: `${maxHeight}px` });
    });

    // Set minHeight for content elements
    this.$content.forEach(($content) => {
      Object.assign($content.style, { minHeight: `${maxHeight}px` });
    });
  }

  toggleActiveClass(clickedLink) {
    // eslint-disable-next-line class-methods-use-this
    const parentLi = clickedLink.closest('.mainnav-content__link');
    const parentUl = parentLi.closest('.mainnav-content__list');
    const siblings = parentUl.querySelectorAll('.mainnav-content__link');

    if (
      parentUl.classList.contains('mainnav-content__list_secondary')
            || parentUl.classList.contains('mainnav-content__list_initial')
    ) {
      siblings.forEach((sibling) => {
        if (sibling !== parentLi) {
          sibling.classList.remove('is-active');
          sibling.querySelector('a')
            .classList
            .remove('active');
        }
      });

      parentLi.classList.toggle('is-active');
      clickedLink.classList.toggle('active');

      if (parentUl.classList.contains('mainnav-content__list_secondary')) {
        const parentInitial = parentUl.closest('.mainnav-content__list_initial');
        const heroInitial = parentInitial.querySelector('.mainnav-content__hero_initial');
        if (heroInitial) {
          heroInitial.classList.add('hidden');
        }
      } else if (parentUl.classList.contains('mainnav-content__list_initial')) {
        const heroInitial = parentUl.querySelector('.mainnav-content__hero_initial');
        if (heroInitial) {
          heroInitial.classList.remove('hidden');
        }
      }
    }

    return this;
  }

  removeActiveClasses(clickedItem) {
    const allItems = this.querySelectorAll('.mainnav__item');
    allItems.forEach((item) => {
      if (item !== clickedItem) {
        item.querySelectorAll('.mainnav__link')
          .forEach((link) => {
            link.classList.remove('is-active');
          });
        item.querySelectorAll('.mainnav-content')
          .forEach((content) => {
            content.classList.remove('is-active');
          });
      }
    });
  }
});
